import type { Infer } from 'superstruct';
import { defaulted, enums, object, string } from 'superstruct';

export const SortDirection = enums(['asc', 'desc'] as const);
export type SortDirection = Infer<typeof SortDirection>;

export interface SortQuery<T extends string = string> {
	sort: T;
	sortDirection: SortDirection;
}

/**
 * @deprecated This does not limit what fields can be sorted by. Use {@link SortQuery} instead.
 */
export const UnsafeSortQuery = object({
	sort: string(),
	sortDirection: SortDirection,
});

/**
 * @deprecated This does not limit what fields can be sorted by. Use {@link SortQuery} instead.
 */
export function UnsafeSortQueryDefaulted(
	defaultSort: string,
	defaultSortDirection: SortDirection
) {
	return object({
		sort: defaulted(UnsafeSortQuery.schema.sort, defaultSort),
		sortDirection: defaulted(
			UnsafeSortQuery.schema.sortDirection,
			defaultSortDirection
		),
	});
}

export function SortQuery<T extends string>(sortableFieldNames: readonly T[]) {
	return object({
		sort: enums(sortableFieldNames),
		sortDirection: SortDirection,
	});
}

export function SortQueryDefaulted<T extends string>(
	sortableFieldNames: readonly T[],
	defaultSort: T,
	defaultSortDirection: SortDirection
) {
	const s = SortQuery(sortableFieldNames);

	return object({
		sort: defaulted(s.schema.sort, defaultSort),
		sortDirection: defaulted(s.schema.sortDirection, defaultSortDirection),
	});
}
